import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import { DropdownItem } from '@platform-ui/design-system';
import kebabCase from 'lodash.kebabcase';
import camelCase from 'lodash.camelcase';
/* Special Snowflake: This uses a custom slot of `this.props.value` and custom defined props */

export var DSDropdownItem = /*#__PURE__*/function (_HTMLElement) {
  _inherits(DSDropdownItem, _HTMLElement);

  var _super = _createSuper(DSDropdownItem);

  _createClass(DSDropdownItem, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(attrName, _, newValue) {
      var _this$comp, _this$comp$__docgenIn, _this$comp$__docgenIn2, _this$comp$__docgenIn3;

      var propName = camelCase(attrName);
      var isBooleanAttr = // @ts-ignore
      ((_this$comp = this.comp) === null || _this$comp === void 0 ? void 0 : (_this$comp$__docgenIn = _this$comp.__docgenInfo) === null || _this$comp$__docgenIn === void 0 ? void 0 : (_this$comp$__docgenIn2 = _this$comp$__docgenIn.props[propName]) === null || _this$comp$__docgenIn2 === void 0 ? void 0 : (_this$comp$__docgenIn3 = _this$comp$__docgenIn2.type) === null || _this$comp$__docgenIn3 === void 0 ? void 0 : _this$comp$__docgenIn3.name) === 'boolean';

      if (isBooleanAttr) {
        this[propName] = [null, undefined].indexOf(newValue) === -1;
      } else {
        this[propName] = newValue;
      }
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      var _this$_props;

      return (_this$_props = this._props) === null || _this$_props === void 0 ? void 0 : _this$_props.map(function (prop) {
        return kebabCase(prop);
      });
    }
  }]);

  function DSDropdownItem() {
    var _this;

    _classCallCheck(this, DSDropdownItem);

    _this = _super.call(this); // @ts-ignore

    _defineProperty(_assertThisInitialized(_this), "comp", DropdownItem);

    _defineProperty(_assertThisInitialized(_this), "elem", void 0);

    _defineProperty(_assertThisInitialized(_this), "props", {});

    _this.constructor._props.forEach(function (prop) {
      Object.defineProperty(_assertThisInitialized(_this), prop, {
        get: function get() {
          return this.props[prop];
        },
        set: function set(newValue) {
          this.props[prop] = newValue;
          this.render();
        }
      });
    });

    return _this;
  }

  _createClass(DSDropdownItem, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      this.elem = /*#__PURE__*/React.createElement(DropdownItem, this.props);
      window.setTimeout(function () {
        _this2.parentElement.render();
      }, 0);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this.style.display = 'none';
      this.render();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.parentElement.render();
    }
  }]);

  return DSDropdownItem;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

_defineProperty(DSDropdownItem, "_props", ['key'].concat(_toConsumableArray(Object.keys(DropdownItem['__docgenInfo'].props))));
//# sourceMappingURL=DropdownItem.js.map